var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNotes(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "notes",
    transform: "translate(-2.25 -3.375)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2159",
    "data-name": "Path 2159",
    d: "M7.875,10.688H20.732v1.538H7.875Z",
    transform: "translate(-2.054 -2.313)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2160",
    "data-name": "Path 2160",
    d: "M7.875,16.875H20.732v1.538H7.875Z",
    transform: "translate(-2.054 -4.269)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2161",
    "data-name": "Path 2161",
    d: "M7.875,23.063h6.786V24.6H7.875Z",
    transform: "translate(-2.054 -6.226)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2162",
    "data-name": "Path 2162",
    d: "M22.25,3.375h-20v20h20ZM20.821,21.837H3.679V4.913H20.821Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotes);
export default __webpack_public_path__ + "static/media/notes.596cb32d8f3e2be8a6f434260647cc50.svg";
export { ForwardRef as ReactComponent };